'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$0024100 from "./presto.-Two-Factor-Auth-View$$anon$100.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002498 from "./presto.-Two-Factor-Auth-View$$anon$98.js";
import * as $j_presto$002etypes$0024$002dGroup from "./presto.types$-Group.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dId$0024 from "./presto.types$-Group-Id$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$97() {
  this.bIY = null;
  this.bIQ = null;
  this.bIR = false;
  this.bIZ = null;
  this.bJ0 = false;
  this.bJ3 = null;
  this.bIW = null;
  this.bIX = false;
  this.bIS = null;
  this.bIT = false;
  this.bIU = null;
  this.bIV = false;
  this.bJ1 = false;
  this.bJ2 = false;
  this.bIY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJ3 = "Group";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$97 as $c_Lpresto_TwoFactorAuthView$$anon$97 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$97.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$97;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$97() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$97 as $h_Lpresto_TwoFactorAuthView$$anon$97 };
$h_Lpresto_TwoFactorAuthView$$anon$97.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bIY;
});
$p.M = (function() {
  if ((!this.bIR)) {
    this.bIQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bIR = true;
  }
  return this.bIQ;
});
$p.O = (function() {
  if ((!this.bJ0)) {
    this.bIZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJ0 = true;
  }
  return this.bIZ;
});
$p.E = (function() {
  return this.bJ3;
});
$p.t = (function() {
  if ((!this.bIX)) {
    this.bIW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bIX = true;
  }
  return this.bIW;
});
$p.N = (function() {
  if ((!this.bIT)) {
    this.bIS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dId$0024.$m_Lpresto_types$GroupId$().p2(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mf(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002498.$c_Lpresto_TwoFactorAuthView$$anon$98())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bIT = true;
  }
  return this.bIS;
});
$p.Q = (function() {
  if ((!this.bIV)) {
    this.bIU = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$0024100.$c_Lpresto_TwoFactorAuthView$$anon$100());
    this.bIV = true;
  }
  return this.bIU;
});
$p.v = (function() {
  if ((!this.bJ2)) {
    this.bJ1 = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), false);
    this.bJ2 = true;
  }
  return this.bJ1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1060) => ((p) => \u03b4scrutinee1060.oY(p)))($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$97 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$97, "presto.TwoFactorAuthView$$anon$97", ({
  TY: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$97 as $d_Lpresto_TwoFactorAuthView$$anon$97 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$97.js.map
